import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "noticeWrapper"
}
const _hoisted_2 = { class: "noticeCard" }
const _hoisted_3 = { class: "topHeader" }
const _hoisted_4 = { class: "noticeHeader" }
const _hoisted_5 = { class: "headerText" }
const _hoisted_6 = { class: "noticeBody" }
const _hoisted_7 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackNotice',
  props: {
    content: {
        type: Array,
        default: () => []
    },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (__props.content?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "leftMain" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('cashback.recompensasPor')), 1)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "rightMain" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "noticeItem",
                key: index,
                innerHTML: item
              }, null, 8, _hoisted_7))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})